import React from "react";
import { makeStyles, ButtonBase, Typography } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import clsx from "clsx";
import { getLang } from "app/feature/constants";

const useStyle = makeStyles((theme) => ({
  root: {
    padding: "5px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    borderRadius: "4px",
    width: "100%",
    border: "1px solid #D0D5DD",
  },
  inputText: {
    fontSize: "14px",
    color: "#A4A6A8",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  filled: {
    color: "rgba(0, 0, 0, 0.87)",
  },
}));

export default function SingleBranchSelectComponent({
  anchorRef,
  handleClick,
  value,
  styles,
  disabled,
  textStyles,
  placeholder,
  lang,
}) {
  const classes = useStyle();

  const getDisplay = () => {
    let display = placeholder || getLang(lang, "placeholder.SELECT_A_BRANCH");
    if (value) {
      display = value.name;
    }
    return display;
  };

  return (
    <ButtonBase
      className={classes.root}
      disableRipple
      ref={anchorRef}
      style={styles}
      onClick={handleClick}
      disabled={disabled}
    >
      <Typography
        variant="caption"
        style={textStyles}
        className={clsx(
          classes.inputText,
          value !== getLang(lang, "placeholder.SELECT_A_BRANCH") &&
            getDisplay() !== placeholder &&
            classes.filled
        )}
      >
        {getDisplay()}
      </Typography>
      <ArrowDropDownIcon fontSize="small" />
    </ButtonBase>
  );
}
